export const localeTextVietnamese = {
  noRowsLabel: "Không có dữ liệu để hiển thị",
  columnMenuSortAsc: "Sắp xếp tăng dần",
  columnMenuSortDesc: "Sắp xếp giảm dần",
  columnMenuHideColumn: "Ẩn cột",
  columnMenuManageColumns: "Quản lý cột",
  columnMenuFilter: "Lọc",
  columnsManagementShowHideAllText: "Hiển thị/Ẩn tất cả",
  filterPanelColumns: "Cột",
  filterPanelOperator: "Thuộc tính",
  filterPanelInputLabel: "Giá trị",
  filterPanelInputPlaceholder: "Giá trị lọc",
  filterOperatorContains: "chứa",
  filterOperatorDoesNotContain: "không chứa",
  filterOperatorEquals: "bằng",
  filterOperatorDoesNotEqual: "không bằng",
  filterOperatorStartsWith: "bắt đầu bằng",
  filterOperatorEndsWith: "kết thúc bằng",
  filterOperatorIs: "là",
  filterOperatorNot: "không phải là",
  filterOperatorAfter: "sau",
  filterOperatorOnOrAfter: "vào hoặc sau",
  filterOperatorBefore: "trước",
  filterOperatorOnOrBefore: "vào hoặc trước",
  filterOperatorIsEmpty: "là rỗng",
  filterOperatorIsNotEmpty: "không rỗng",
  filterOperatorIsAnyOf: "là một trong số",
  checkboxSelectionHeaderName: "Ô chọn",
  columnsManagementReset: "Làm mới",
  columnMenuUnsort: "Bỏ sắp xếp",
  noResultsOverlayLabel: "Không có dữ liệu hiển thị",
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} dòng được chọn`
      : `${count.toLocaleString()} dòng được chọn`,
  MuiTablePagination: {
    labelRowsPerPage: "Số dòng trên trang"
  },
};
